import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';

export const getTechnicianVisitData = createAsyncThunk(
  'technicianUpdatesBlock/getTechnicianVisitData',
  async (data, thunkAPI) => {
    try {
      const result = await ProviderManager.getProviderData('getTechnicianVisitData', []);
      return result;
    } catch (error) {
      thunkAPI.dispatch(setErrorId({id: 1075})); // 1075 - GENERAL_ERROR
      thunkAPI.dispatch(goToPage("errorPage"));
      return error;
    }
  }
);

export const getTechnicianTimeSlots = createAsyncThunk(
  'technicianUpdatesBlock/getTechnicianTimeSlots',
  async (data, thunkAPI) => {
    try {
      const result = await ProviderManager.getProviderData('getTechnicianTimeSlots', data);
      return {timeSlots: result.Body.timeSlots , isBezeqWithCellcom: result.Body.isBezeqWithCellcom  };
    } catch (error) {
      switch(error.errorCode){
        case 1071:// TECHNICIAN_UPDATE_TIME_ERROR
          thunkAPI.dispatch(setIsShowErrorPopup({isShow: true, type: "TECHNICIAN_UPDATE_TIME_ERROR"}));
          break;
        case 1072:// TECHNICIAN_UPDATE_MAXIMUM_SLOTS_ERROR
          break;
        default:
          thunkAPI.dispatch(setErrorId({id: 1076}));
          thunkAPI.dispatch(goToPage("errorPage"));
          break;
      }
      return error;
    }
  }
);

export const updateTechnicianTimeSlot = createAsyncThunk(
  'technicianUpdatesBlock/updateTechnicianTimeSlot',
  async (data, thunkAPI) => {
    try {
      const result = await ProviderManager.getProviderData('updateTechnicianTimeSlot', data);
      return {isSuccess: result.Body };
    } catch (error) {
      thunkAPI.dispatch(setErrorId({id: error.errorCode})); 
      switch(error.errorCode){
        case 1073: // TECHNICIAN_UPDATE_BEZEQ_CELLCOM_RANGE_ERROR
          thunkAPI.dispatch(setCurrentSelectedTimeSlot(null));
          // thunkAPI.dispatch(goToPage("technicianTimeSlotsCellcomPage"));
          break;
        default:
          thunkAPI.dispatch(setIsShowErrorPopup({isShow: true, type: "TECHNICIAN_UPDATE_GENERAL_ERROR"}));
      }
      return error;
    }
  }
);

export const checkIsVisitTimeSlotCancelable = createAsyncThunk(
  'technicianUpdatesBlock/checkIsVisitTimeSlotCancelable',
  async (data, thunkAPI) => {
    try {
      const result = await ProviderManager.getProviderData('checkIsVisitTimeSlotCancelable', [data]);
      return {isCancelable: result.Body };
    } catch (error) {
      thunkAPI.dispatch(setIsShowErrorPopup({isShow: true, type: "TECHNICIAN_CANCEL_GENERAL_ERROR"}));
      return error;
    }
  }
);

export const cancelTechnicianTimeSlot = createAsyncThunk(
  'technicianUpdatesBlock/cancelTechnicianTimeSlot',
  async (data, thunkAPI) => {
    try {
      const result = await ProviderManager.getProviderData('cancelTechnicianTimeSlot', [data]);
      return {isSuccess: result.Body };
    } catch (error) {
      switch(error.errorCode){
        case 1074:
          thunkAPI.dispatch(setIsShowErrorPopup({isShow: true, type: "TECHNICIAN_CANCEL_TIME_ERROR"}));
          break;
        default:
          thunkAPI.dispatch(setErrorId({id: 1077}));
          thunkAPI.dispatch(goToPage("errorPage"));
          break;
      }
      return error;
    }
  }
);

const initialState = {
  epiServer: {
    blockId: 0,
  },
  page: "customerVisitInfoPage",
  technicianVisits: [],
  selectedVisit: null,
  selectedTimeSlots: [],
  currentSelectedTimeSlot: null,
  successPageType: "",
  technicianTimeSlots : {timeSlots : [] , isBezeqWithCellcom: false },
  technicianTimeSlotPage:{ index: 0, count: 10, timeSlots: [], isDisplayShowMoreBtn: true},
  errorPopup: { isShow: false, type: "" },
  isShowCancelPopUp: false,
  title: "",
  error: {id: null},
  reportDWH:{actionType: "" , status: "" , messageText: "" }
};

const technicianUpdatesBlockSlice = createSlice({
  name: 'technicianUpdatesBlock',
  initialState: initialState,
  reducers: {
    resetBlock: (state) => initialState,
    initTechnicianUpdates: (state, action) => {
        state.epiServer.blockId = action.payload.technicianUpdatesBlock.contentLink.id;
        state.page = "customerVisitInfoPage";
        state.selectedVisit = null;
        state.title = "הטכנאים שמתואמים עבורך";
        state.technicianTimeSlotPage = { index: 0, count: 10, timeSlots: [], isDisplayShowMoreBtn: true };
        state.error = {id: null}
    },
    goToPage: (state, action) => {
      state.page = action.payload;
    },
    setTitle: (state, action) => {
      state.title = action.payload;
    },
    setSelectedVisit: (state, action) => {
        state.selectedVisit = action.payload;
    },
    setSelectedTimeSlots: (state, action) => {
      state.currentSelectedTimeSlot = action.payload;
      var indexOfSlot = state.selectedTimeSlots.findIndex(x => x.type == action.payload.type);
      if(indexOfSlot == -1){
        state.selectedTimeSlots = state.selectedTimeSlots.concat(action.payload);
      }
      else{
        state.selectedTimeSlots[indexOfSlot] = action.payload;
      }
    },
    setCurrentSelectedTimeSlot: (state, action) => {
      state.currentSelectedTimeSlot = action.payload;
    },
    setErrorId: (state, action) => {
      state.error.id = action.payload.id;
    },
    resetTechnicianTimeSlots: (state, action) => {
      state.technicianTimeSlots = {timeSlots : [] , isBezeqWithCellcom: false };
      state.technicianTimeSlotPage = { index: 0, count: 10, timeSlots: [], isDisplayShowMoreBtn: true };
    },
    resetSelectedTimeSlots: (state, action) => {
      state.selectedTimeSlots = [];
      state.currentSelectedTimeSlot = null;
    },
    setIsShowErrorPopup:(state, action) => {
      state.errorPopup = {isShow: action.payload.isShow, type: action.payload.type };
    },
    setIsShowCancelPopup:(state, action) => {
      state.isShowCancelPopUp = action.payload;
    },
    showMoreTimeSlots:(state, action) => {
      if(state.technicianTimeSlotPage.timeSlots.length == state.technicianTimeSlots.timeSlots.length){
        state.technicianTimeSlotPage.isDisplayShowMoreBtn = false;
      }
      else{
        let timeSlotsSlice = state.technicianTimeSlots.timeSlots.slice(state.technicianTimeSlotPage.index, state.technicianTimeSlotPage.index + 10);
        state.technicianTimeSlotPage.timeSlots = state.technicianTimeSlotPage.timeSlots.concat(timeSlotsSlice);
        state.technicianTimeSlotPage.index += 10;
      }
    },
    setIsDisplayShowMoreBtn:(state, action) => {
      state.technicianTimeSlotPage.isDisplayShowMoreBtn = action.payload;
    },
    pageLoaded:(state, action) => {
    },
    reportAnalytics:(state, action) => {
    },
    reportDWH: (state, action) => {
    },  
  },
  extraReducers: {
    [getTechnicianVisitData.fulfilled]: (state, action) => {
      state.technicianTimeSlotPage = { index: 0, count: 10, timeSlots: [], isDisplayShowMoreBtn: true };
      state.currentSelectedTimeSlot = null;
      state.selectedTimeSlots = [];
      if (action.payload.Body) {
        state.technicianVisits = action.payload.Body;
        if(action.payload.Body.length == 0){
          state.page = "errorPage";
          state.error.id = 1078; //Not found technician visits
        }
      }
    },
    [getTechnicianTimeSlots.fulfilled]: (state, action) => {
      state.technicianTimeSlotPage = { index: 0, count: 10, timeSlots: [], isDisplayShowMoreBtn: true };
      state.technicianTimeSlots = {timeSlots : [] , isBezeqWithCellcom: false };
      if (action.payload.timeSlots) {
        state.technicianTimeSlots = {timeSlots : state.technicianTimeSlots.timeSlots.concat(action.payload.timeSlots) , isBezeqWithCellcom: action.payload.isBezeqWithCellcom  } ;
        if(action.payload.timeSlots.length == 0){
          state.page = "errorPage";
          state.error.id = 1076; // Not found time slots 
        }
      }
    },
    [updateTechnicianTimeSlot.fulfilled]: (state, action) => {
      if (action.payload) {
          if(action.payload.isSuccess == true){
            state.page = "successPage";
            state.successPageType = "update";
            state.currentSelectedTimeSlot = null;
            state.selectedTimeSlots = [];
          }
          else if(action.payload.isSuccess == false){ //מישו תפס את המועד שבחרת
            state.errorPopup = {isShow: true , type: "TECHNICIAN_UPDATE_TIME_SLOT_UNAVAILABLE_ERROR" };
          }
      }
    },
    [checkIsVisitTimeSlotCancelable.fulfilled]: (state, action) => {
      if(action.payload){
        if(action.payload?.isCancelable == true){
          state.isShowCancelPopUp = true;
        }
        else if(action.payload?.isCancelable == false){
          state.errorPopup = {isShow: true , type: "TECHNICIAN_CANCEL_TIME_ERROR" };
        }
      }
    },
    [cancelTechnicianTimeSlot.fulfilled]: (state, action) => {
      state.isShowCancelPopUp = false;
      if (action.payload) {
        if(action.payload.isSuccess == true){
          state.page = "successPage";
          state.successPageType = "cancel";
          state.currentSelectedTimeSlot = null;
        }
        else if(action.payload.isSuccess == false){
          state.page = "errorPage";
          state.error.id = 1077; 
        }
    }
    },
  }
});

export const {
  resetBlock,
  initTechnicianUpdates,
  goToPage,
  pageLoaded,
  setTitle,
  setErrorId,
  setSelectedVisit,
  setSelectedTimeSlots,
  resetSelectedTimeSlots,
  setCurrentSelectedTimeSlot,
  resetTechnicianTimeSlots,
  setIsShowErrorPopup,
  setIsShowCancelPopup,
  reportAnalytics,
  showMoreTimeSlots,
  setIsDisplayShowMoreBtn,
  reportDWH
} = technicianUpdatesBlockSlice.actions;

export default technicianUpdatesBlockSlice.reducer;











